<template>
  <div class="dialog-pdf-to-image-thumb" :style="{height: `${this.height + 2}px`, width: `${this.width + 2}px`}">
    <div v-show="state.loaded == false" class="dialog-pdf-to-image-thumb-loader">
      <q-spinner
        color="primary"
        size="3em"
      />
    </div>
    <canvas v-show="state.loaded" ref="image" :height="height" width="50"/>
    <div v-show="state.loaded" class="dialog-pdf-to-image-thumb-overlay jijo" :class="{selected: selectedIndex == index}" @click="listen__overlay__onclick">
      <div class="mark-select">
        <q-icon name="check_circle" size="sm" />
      </div>
    </div>
  </div>
</template>

<script>
import MISC from '@/js/miscellaneous.js'

export default {
  props: ['pdf', 'index', 'selected-index'],
  data: function () {
    return {
      height: 200,
      width: 100,
      state: {
        loaded: false,
        width: null,
        height: null
      }
    }
  },
  methods: {
    listen__overlay__onclick: function () {
      const Vue = this
      Vue.$emit('onselect', {index: Vue.index, width: Vue.state.width, height: Vue.state.height})
    }
  },
  mounted: async function () {
    const Vue = this

    let page = await Vue.pdf.getPage(Vue.index + 1)
    let viewport = page.getViewport({scale: 1})
    Vue.state.width = viewport.width
    Vue.state.height = viewport.height

    let scale = Vue.height / viewport.height
    let width = parseInt(viewport.width * scale)
    Vue.width = width
    Vue.$refs['image'].width = width
    MISC.doubleRaf(async() => {
      viewport = page.getViewport({scale: scale})
      let render_context = {
        canvasContext: Vue.$refs['image'].getContext('2d'),
        viewport: viewport
      }

      try {
        await page.render(render_context)
      } catch (err) {
        console.log(err)
      }
      Vue.state.loaded = true
    })
  }
}
</script>

<style scoped>
.dialog-pdf-to-image-thumb {
  position: relative;
  border: 1px solid black;
  box-shadow: 10px 5px 5px rgb(0, 0, 0, 0.15);
  margin: 10px;
}

.dialog-pdf-to-image-thumb-loader {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.dialog-pdf-to-image-thumb-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.dialog-pdf-to-image-thumb-overlay:hover {
  background: #027BE310;
}

.dialog-pdf-to-image-thumb-overlay.selected {
  background: #027BE330;
  cursor: default;
}

.dialog-pdf-to-image-thumb-overlay > .mark-select {
  position: absolute;
  top: 3px;
  left: 3px;
  color: #027BE3;
  visibility: hidden;
}

.dialog-pdf-to-image-thumb-overlay.selected > .mark-select {
  visibility: visible;
}
</style>